// Helpers
import { to } from '../../../lib/helpers';

// Requests
import { userGetContactsRequest } from '../../../backend/userRequests';

// Consts
export const USER_GET_CONTACTS_SUCCESS_RECEIVED = '[USER] Get Contacts Success';

export const getContacts = () => {
  return async dispatch => {
    const [{ response, body }] = await to(dispatch(userGetContactsRequest()));

    if (!body) return false;
    if (response.status !== 200) return Promise.reject({ response, body });

    const contacts = {
      email: body.data.filter(contact => contact.typeCode === 'PE')[0] || {},
      phone:
        body.data.filter(
          contact => contact.typeCode === 'PM' || contact.typeCode === 'PL'
        )[0] || {},
      workEmail:
        body.data.filter(contact => contact.typeCode === 'WE')[0] || {},
    };

    dispatch({ type: USER_GET_CONTACTS_SUCCESS_RECEIVED, payload: contacts });

    return Promise.resolve({ response, body: contacts });
  };
};
